import axios, { AxiosError, isAxiosError } from 'axios'

export enum ERROR_TYPE {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  USER_FAILED = 'USER_FAILED',
  USER_FIELDS_ERROR = 'USER_FIELDS_ERROR'
}

enum ERROR_MESSAGE {
  ALREADY_CREATED = 'alreadyCreated',
  WRONG_LANGUAGE_COMBINATION = 'wrongLanguageCombination'
}

const ERROR_MESSAGE_KEYS: { [key: string]: string } = {
  [ERROR_MESSAGE.ALREADY_CREATED]: 'error.case_already_open',
  [ERROR_MESSAGE.WRONG_LANGUAGE_COMBINATION]: 'error.wrong_language_combination'
}

export type ResponseError = {
  type: ERROR_TYPE
  message: ERROR_MESSAGE
}

const wrongCombinationError = (message: ERROR_MESSAGE) => {
  const regex = /^Wrong language '.*?'\+ physicianCountry '.*?'settings\. Please provide a supported combination\.$/
  const match = message.match(regex)
  return Boolean(match)
}

export const getErrorMessage = (error: Error) => {
  if (!axios.isAxiosError(error)) return

  const errorData = (error as AxiosError<ResponseError>).response?.data
  if (!errorData) return

  if (wrongCombinationError(errorData.message)) return ERROR_MESSAGE_KEYS[ERROR_MESSAGE.WRONG_LANGUAGE_COMBINATION]
  return ERROR_MESSAGE_KEYS[errorData.message] || ERROR_MESSAGE_KEYS[errorData.type]
}

const IGNORED_ERRORS: (ERROR_TYPE | ERROR_MESSAGE)[] = [ERROR_TYPE.USER_FAILED, ERROR_MESSAGE.ALREADY_CREATED]
export const isErrorIgnored = (error: unknown) => {
  if (!isAxiosError(error)) return false

  const errorData = (error as AxiosError<ResponseError>).response?.data
  if (!errorData) return false

  return Boolean(error && (IGNORED_ERRORS.includes(errorData.type) || IGNORED_ERRORS.includes(errorData.message)))
}

export const isAbortError = (error: unknown): boolean => {
  const errorName = (error as Error)?.name
  const errorCode = (error as any)?.code

  return ['CanceledError', 'AbortError'].includes(errorName) || errorCode === 'ERR_CANCELED' || errorName?.startsWith('ERR_CANCELED')
}
